module.exports = __webpack_public_path__ + "static/media/daily absent report.eb4a751a.svg";